import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { SearchTypes } from '../../search.types';
import styles from './search_zero_results_help.module.scss';

type Props = {
  searchType: SearchTypes;
};

export const SearchZeroResultsHelp: FC<Props> = ({ searchType }) => {
  const trackClick = () => {
    doctrineAnalytics('Search HelpClicked', {
      search_type: searchType,
    });
  };
  return (
    <div>
      <i className={styles.icon} />
      <a
        className={styles.link}
        href="/aide/recherche?source=search-zero-result"
        target="_blank"
        onClick={trackClick}
      >
        <FormattedMessage id="app.pages.search.zeroResults.help" />
      </a>
    </div>
  );
};
